import { ofType } from "redux-observable";
import { of } from "rxjs";
import { concat } from "rxjs";
import normalize from "json-api-normalizer";
import { map, mergeMap } from "rxjs/operators";
import { parseError } from "./lib";

import TreatmentCodeService from "../services/treatmentCodeService";

import {
  loadTreatmentCodesSuccess,
  loadTreatmentCodesFailure,
  LOAD_TREATMENT_CODES_REQUEST_ACTION,
  SAVE_TREATMENT_CODE_REQUEST_ACTION,
  saveTreatmentCodeFailure,
  saveTreatmentCodeSuccess,
  DELETE_TREATMENT_CODE_REQUEST_ACTION,
  deleteTreatmentCodeFailure,
  deleteTreatmentCodeSuccess,
  SAVE_TREATMENT_CODE_SUCCESS_ACTION,
  saveTreatmentCodeRequest,
  SAVE_TREATMENT_CODE_FAILURE_ACTION
} from "../ducks/data";
import { setActiveDialog } from "../ducks/app";

import {
  saveTreatmentCodeFormSuccess,
  saveTreatmentCodeFormFailure,
  SAVE_TREATMENT_CODE_FORM_REQUEST_ACTION,
  SAVE_TREATMENT_CODE_FORM_SUCCESS_ACTION
} from "../ducks/treatmentCode";

import { loadTreatmentCodesRequest } from "../ducks/data";

export const reloadTreatmentCodesAfterSaveEpic = action$ =>
  action$.pipe(
    ofType(SAVE_TREATMENT_CODE_FORM_SUCCESS_ACTION.getType()),
    map(() => {
      return loadTreatmentCodesRequest(); // triggers re-fetch
    })
  );

export const loadTreatmentCodesEpic = (action$, state$) =>
  action$.pipe(
    ofType(LOAD_TREATMENT_CODES_REQUEST_ACTION.getType()),
    mergeMap(action => {
      let treatmentCodeService = new TreatmentCodeService();
      return treatmentCodeService
        .findAll(action.payload)
        .then(response => {
          return loadTreatmentCodesSuccess(response.data);
        })
        .catch(error => {
          return loadTreatmentCodesFailure(parseError(error));
        });
    })
  );

export const saveTreatmentCodeFormRequestEpic = (action$, state$) =>
  action$.pipe(
    ofType(SAVE_TREATMENT_CODE_FORM_REQUEST_ACTION.getType()),
    mergeMap(action => {
      return of(saveTreatmentCodeRequest(action.payload));
    })
  );

export const saveTreatmentCodeFormSuccessEpic = (action$, state$) =>
  action$.pipe(
    ofType(SAVE_TREATMENT_CODE_SUCCESS_ACTION.getType()),
    mergeMap(action => {
      return concat(
        of(saveTreatmentCodeFormSuccess(action.payload.user)),
        of(setActiveDialog())
      );
    })
  );

export const saveTreatmentCodeFormFailureEpic = (action$, state$) =>
  action$.pipe(
    ofType(SAVE_TREATMENT_CODE_FAILURE_ACTION.getType()),
    mergeMap(action => {
      // TODO: check result for validation failure or communication failure based on status
      return of(saveTreatmentCodeFormFailure(action.payload));
    })
  );

export const saveTreatmentCodeEpic = (action$, state$) =>
  action$.pipe(
    ofType(SAVE_TREATMENT_CODE_REQUEST_ACTION.getType()),
    mergeMap(action => {
      let service = new TreatmentCodeService();
      return concat(
        service
          .save(action.payload)
          .then(response => {
            return saveTreatmentCodeSuccess(normalize(response.data));
          })
          .catch(error => {
            return saveTreatmentCodeFailure(parseError(error));
          })
      );
    })
  );

export const deleteTreatmentCodeEpic = (action$, state$) =>
  action$.pipe(
    ofType(DELETE_TREATMENT_CODE_REQUEST_ACTION.getType()),
    mergeMap(action => {
      let service = new TreatmentCodeService();
      return concat(
        service
          .archive(action.payload)
          .then(response => {
            return deleteTreatmentCodeSuccess(action.payload);
          })
          .catch(error => {
            return deleteTreatmentCodeFailure(parseError(error));
          }),
        of(setActiveDialog()),
        of(loadTreatmentCodesRequest())
      );
    })
  );



// WEBPACK FOOTER //
// ./src/epics/treatment_codes.js